module.exports = __webpack_public_path__ + "static/latestClaims-4369305508d75a880f1af5934cdfef68.jpg";